function Navbar() {
  return (
    <div style={{ padding: 10, background: "#3a413a", color: "white" }}>
      <h3>Surplus Saver</h3>
    </div>
  );
}

export default Navbar;